export enum PaymentMethod {
  PREPAYMENT = 'PREPAYMENT',
  TRANSFER = 'TRANSFER',
}
